(function () {
	window.addEventListener('DOMContentLoaded', () => {
		const newsletter_btn = document.querySelector('.newsletter-field__submit button');
 	 	const newsletter_close = document.querySelector('.js-newsletter-modal__close');
		const newsletter_popup = document.querySelector('.js-newsletter-modal');
    const subscribeButton = document.querySelector('.js-subscribe-button');
    const subscribeContent = document.querySelector('.js-news-letter-modal__subscribe');
    const newsLetterForm = document.querySelector('.js-newsletter-modal__form');
    const fieldButton = document.querySelector('.newsletter-field__button');
    const successCloseButton = document.querySelector('.js-button-success');
    const errorCloseButton = document.querySelector('.js-button-error');
    const successModal = document.querySelector('.js-newsletter-modal__success');
    const errorModal = document.querySelector('.js-newsletter-modal__error');
    const modalWrapper = document.querySelector('.js-newsletter-modal__group');
    
    if (window.location.href.indexOf("#join-us") > -1) {
      displayPopup();
    }

    function displayPopup(){
      newsletter_popup.style.display = 'block';
      lastScroll = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      localStorage.setItem('popup', 'off');
      subscribeContent.classList.remove('is-hidden');
      newsLetterForm.classList.remove('is-shown');
    }

    function getCookie(name) {
      let cookie = {};
      document.cookie.split(';').forEach(function(index) {
        let [key,value] = index.split('=');
        cookie[key.trim()] = value;
      })
      return cookie[name];
    }
  
    if (getCookie("age_gate") == "off") {
      let timeout = setTimeout( () => {
        displayPopup();
      }, 15000);
          
      if (localStorage.getItem('popup') == 'off') {
        window.clearTimeout(timeout);
      }

      fieldButton.addEventListener('click', function() {
        window.clearTimeout(timeout);
      });

    } 
    
    fieldButton.addEventListener('click', function() {
      subscribeContent.classList.add('is-hidden');
      newsLetterForm.classList.add('is-shown');
    });

    // Remove the sessionStorage on closing the tab/windows
    if (sessionStorage.getItem('popup') === 'true') {
      sessionStorage.removeItem('popup');
    }

    // Open Modal
    newsletter_btn.addEventListener('click', function(e) {
      e.preventDefault();
      newsletter_popup.style.display = 'block';
      lastScroll = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      setTimeout(() => {
        document.body.style.top = '-' + lastScroll + 'px';
      }, 0);
    });

    // Close Modal
    newsletter_close.addEventListener('click', function(e) {
      newsletter_popup.style.display = 'none';
      e.preventDefault();
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.scrollTo(0, lastScroll * -1);
    });

    document.addEventListener('click', function(e) {
      let newsletter_wrap = e.target.classList.contains('js-newsletter-modal') ? e.target : e.target.closest('.js-newsletter-modal');
      if (newsletter_wrap) {
        e.stopPropagation();
      }
    });

    subscribeButton.addEventListener('click', function() {
      subscribeContent.classList.add('is-hidden');    
      newsLetterForm.classList.add('is-shown');
      subscribeContent.classList.add('is-hidden');   
    });
    
    // close after success
    successCloseButton.addEventListener('click', function(e) {
      newsletter_popup.style.display = 'none';
      e.preventDefault();
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
      successModal.classList.remove('is-show');
      modalWrapper.classList.remove('is-hidden');
    });

    // close after error 
    errorCloseButton.addEventListener('click', function(e) {
      newsletter_popup.style.display = 'none';
      e.preventDefault();
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
      errorModal.classList.remove('is-show');
      modalWrapper.classList.remove('is-hidden');
    });

	});
})();
